import axios from "axios";
import authHeader from "@/services/auth.header";
import { HTTP } from "@/http/config";
import { AnyObject } from "yup";
const API_URL = HTTP.api_url;

class CitaService {
  async getIndex(): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + "citas", { headers: authHeader() })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
  async getfilter(search): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + `citas/filter-cita`, {
        params: search,
        headers: authHeader(),
      })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }

  async getfilterTemp(search): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + `citas/filter-cita-temp`, {
        params: search,
        headers: authHeader(),
      })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
  /*  */
  async getCitaMonth(fecha): Promise<AnyObject> {    
    const response = await axios.get(API_URL + `citas/list-cita?date=${fecha}`, {        
        headers: authHeader(),
      })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        console.log(error)
         const dataError = JSON.stringify(error.response.data);
         console.log(dataError);
      });
    return response;
  }
  async getCitaMonthTemp(fecha): Promise<AnyObject> {    
    const response = await axios.get(API_URL + `citas/list-cita-temp?date=${fecha}`, {        
        headers: authHeader(),
      })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        console.log(error)
         const dataError = JSON.stringify(error.response.data);
         console.log(dataError);
      });
    return response;
  }
  async getSearch(search): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + `citas/getCitaDay`, {
        params: search,
        headers: authHeader(),
      })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {        
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
  async getSearchTemp(search): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + `citas/getCitaDayTemp`, {
        params: search,
        headers: authHeader(),
      })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {        
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
  async getlist(pageNumber): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + `citas/getCitaDay?page=${pageNumber}`, {
        headers: authHeader(),
      })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
   async getlistTemp(pageNumber): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + `citas/getCitaDayTemp?page=${pageNumber}`, {
        headers: authHeader(),
      })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
  async postCreated(citas): Promise<AnyObject> {
    const response = await axios
      .post(API_URL + "citas", citas, { headers: authHeader() })
      .then((response) => {
        // console.log(response.data)
        return response.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }

  async postUpdate(id, citas): Promise<AnyObject> {
    const response = await axios
      .put(
        API_URL + `citas/${id}`,
        { id: Number(id), ...citas },
        { headers: authHeader() }
      )
      .then((response) => {
        //console.log(response.data)
        return response?.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }

  async getEdit(id): Promise<AnyObject[]> {
    const response = await axios
      .get(API_URL + `citas/${id}`, { headers: authHeader() })
      .then((response) => {
        return response?.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }

  async getDelete(id): Promise<AnyObject> {
    const response = await axios
      .delete(API_URL + `citas/${id}`, { headers: authHeader() })
      .then((response) => {
        return response?.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }
  async getCancel(id): Promise<AnyObject> {
    const response = await axios
      .delete(API_URL + `citas/cancelar/${id}`, { headers: authHeader() })
      .then((response) => {
        return response?.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }

  async getListCita(search):Promise<AnyObject>{
    const response = await axios
    .get(API_URL + `citas/cita-fecha`, {
      params: search,
      headers: authHeader(),
    })
    .then((response) => {      
      return response.data;
    })
    .catch((error) => {        
      const dataError = JSON.stringify(error.response.data);
      console.log(dataError);
    });
  return response;
  }
}
export default new CitaService();
